import { useState } from "react";

export default function RichTextColorPicker({ expanded, onExpandEvent, onChange, currentState }) {
  const [hex, setHex] = useState("#000000");

  const apply = (colorType) => {
    const value = hex.startsWith("#") ? hex : `#${hex}`;
    if (/^#[0-9A-Fa-f]{6}$/.test(value)) {
      onChange(colorType, value);
    }
  };

  return (
    <div className="rdw-option-wrapper" style={{ position: "relative", display: "inline-block" }}>
      {/* Trigger button */}
      <button
        type="button"
        onClick={(e) => { onExpandEvent(); }}
        title="Cor"
        style={{
          display: "flex",
          background: "none",
          border: "none",
          borderRadius: 2,
          cursor: "pointer",
          fontWeight: "bold",
          fontSize: 14,
          lineHeight: 1,
          margin: 'auto'
        }}
      >
        <span style={{ position: "relative" }}>
          A
          <span
            style={{
              position: "absolute",
              bottom: -3,
              left: 0,
              right: 0,
              height: 3,
              background: currentState?.color || "#000000",
              borderRadius: 1,
            }}
          />
        </span>
      </button>

      {/* Dropdown */}
      {expanded && (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            zIndex: 1000,
            background: "#fff",
            border: "1px solid #e0e0e0",
            borderRadius: 6,
            padding: 12,
            boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
            minWidth: 220,
          }}
        >
          <div style={{ position: "relative", display: "flex", gap: 8, alignItems: "center", marginBottom: 10 }}>
            <div
              style={{
                width: 36,
                height: 36,
                border: "1px solid #ddd",
                borderRadius: 4,
                flexShrink: 0,
                background: /^#[0-9A-Fa-f]{6}$/.test(hex) ? hex : "#000000",
              }}
            />
            <input
              type="text"
              value={hex}
              onChange={(e) => setHex(e.target.value)}
              placeholder="#000000"
              maxLength={7}
              style={{
                flex: 1,
                border: "1px solid #ccc",
                borderRadius: 4,
                padding: "5px 8px",
                fontFamily: "monospace",
                fontSize: 13,
                outline: "none",
              }}
            />
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button
              type="button"
              onClick={() => apply("color")}
              style={{
                flex: 1,
                padding: "6px 4px",
                cursor: "pointer",
                border: "none",
                borderRadius: 4,
                fontSize: 12,
                fontWeight: 500,
                background: "#1976d2",
                color: "#fff",
              }}
            >
              Cor do texto
            </button>
            <button
              type="button"
              onClick={() => apply("bgcolor")}
              style={{
                flex: 1,
                padding: "6px 4px",
                cursor: "pointer",
                border: "none",
                borderRadius: 4,
                fontSize: 12,
                fontWeight: 500,
                background: "#e65100",
                color: "#fff",
              }}
            >
              Cor de fundo
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
